import {
  CONTENT_ICON_ALIASES,
  CONTENT_ICON_DEFINITIONS,
  CONTENT_ICON_SPRITE,
  CONTENT_ICON_UNICODES,
} from './content-icon-catalog';

function iconName(attributes: string) {
  const match = attributes.match(/\bclass\s*=\s*(?:"([^"]*)"|'([^']*)')/i);
  return (match?.[1] ?? match?.[2] ?? '').split(/\s+/)
    .map(token => token.startsWith('fa-') ? CONTENT_ICON_ALIASES[token.slice(3)] : undefined)
    .find(Boolean);
}

function glyphName(text: string) {
  const normalized = text.trim().replace(/&#(?:x([a-f0-9]+)|(\d+));/gi, (_, hex, decimal) =>
    String.fromCodePoint(parseInt(hex ?? decimal, hex ? 16 : 10)));
  if ([...normalized].length !== 1) return undefined;
  return CONTENT_ICON_UNICODES[normalized.codePointAt(0)!.toString(16)];
}

function svg(name: string) {
  const definition = CONTENT_ICON_DEFINITIONS[name];
  return `<svg data-content-icon="${name}" viewBox="${definition.viewBox}" aria-hidden="true" focusable="false" style="display:inline-block;width:${definition.width}em;height:1em;vertical-align:-.125em;flex-shrink:0;fill:currentColor"><use href="${CONTENT_ICON_SPRITE}#${name}"></use></svg>`;
}

/**
 * Preserve trusted CMS HTML byte-for-byte except standalone legacy icon glyphs.
 * No parser dependency, sanitizer changes, font download or client observer.
 * Script/style content and non-icon italic/text spans are never rewritten.
 */
export function replaceContentFontIcons(html: string) {
  if (!/fa-|[\ue000-\uf8ff]|&#(?:x[a-f0-9]+|\d+);/i.test(html)) return html;
  return html.split(/(<script\b[^>]*>[\s\S]*?<\/script>|<style\b[^>]*>[\s\S]*?<\/style>)/gi)
    .map((part, index) => index % 2 ? part : part
      .replace(/<i\b([^>]*)>([^<]*)<\/i>/gi, (original, attributes: string, text: string) => {
        const name = iconName(attributes);
        // Do not replace an italic text element that merely has an icon class.
        if (!name || (text.trim() && !glyphName(text))) return original;
        return `<span data-content-icon-wrapper="true"${attributes}>${svg(name)}</span>`;
      })
      .replace(/<span\b([^>]*)>(\s*(?:[\ue000-\uf8ff]|&#(?:x[a-f0-9]+|\d+);)\s*)<\/span>/gi,
        (original, attributes: string, text: string) => {
          const name = glyphName(text);
          if (!name) return original;
          const cleanAttributes = attributes.replace(/font-family\s*:\s*[^;]*Font Awesome[^;]*(?:;|(?=["']))/gi, '');
          return `<span${cleanAttributes}>${svg(name)}</span>`;
        }))
    .join('');
}
